/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_SpanishInputs */

const en_speechmatics_target_language_spanish = /** @type {(inputs: Speechmatics_Target_Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spanish`)
};

const fr_speechmatics_target_language_spanish = /** @type {(inputs: Speechmatics_Target_Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espagnol`)
};

const de_speechmatics_target_language_spanish = /** @type {(inputs: Speechmatics_Target_Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spanisch`)
};

const it_speechmatics_target_language_spanish = /** @type {(inputs: Speechmatics_Target_Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`spagnolo`)
};

const ru_speechmatics_target_language_spanish = /** @type {(inputs: Speechmatics_Target_Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`испанский`)
};

const es_speechmatics_target_language_spanish = /** @type {(inputs: Speechmatics_Target_Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

const zh_cn2_speechmatics_target_language_spanish = /** @type {(inputs: Speechmatics_Target_Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`西班牙语`)
};

const ja_speechmatics_target_language_spanish = /** @type {(inputs: Speechmatics_Target_Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペイン語`)
};

const hi_speechmatics_target_language_spanish = /** @type {(inputs: Speechmatics_Target_Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पैनिश`)
};

const pt_pt2_speechmatics_target_language_spanish = /** @type {(inputs: Speechmatics_Target_Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espanhol`)
};

/**
* | output |
* | --- |
* | "Spanish" |
*
* @param {Speechmatics_Target_Language_SpanishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_spanish = /** @type {((inputs?: Speechmatics_Target_Language_SpanishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_SpanishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_spanish(inputs)
	if (locale === "de") return de_speechmatics_target_language_spanish(inputs)
	if (locale === "it") return it_speechmatics_target_language_spanish(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_spanish(inputs)
	if (locale === "es") return es_speechmatics_target_language_spanish(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_spanish(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_spanish(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_spanish(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_spanish(inputs)
	return en_speechmatics_target_language_spanish(inputs)
});